import { createSlice } from "@reduxjs/toolkit";

export const ticketDashboardSlice = createSlice({
  name: "ticketDashboard",
  initialState: {
    getTicketDashboardResult: false,
    getTicketDashboardLoading: false,
    getTicketDashboardError: false,
  },
  reducers: {
    ticketDashboardReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKETDASHBOARD":
          return {
            ...state,
            getTicketDashboardResult: payload.data,
            getTicketDashboardLoading: payload.loading,
            getTicketDashboardError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketDashboardReducers } = ticketDashboardSlice.actions;

export default ticketDashboardSlice.reducer;
